/**
 * tileBodyFit — how a text tile's paragraphs show inside the height they get.
 *
 * On desktop the text tile is bound to the card rhythm (as tall as the
 * neighbours' photos), so its paragraphs only get what the title and the link
 * leave over:
 *   'fits'    — everything is visible;
 *   'clipped' — the copy runs on under a fade at the bottom of the box;
 *   'hidden'  — fewer than MIN_LINES lines would show; the paragraphs go
 *               (a line or two under a fade reads as a glitch).
 *
 * @param {{ scrollHeight: number, clientHeight: number, lineHeight: number }} box
 * @returns {'fits' | 'clipped' | 'hidden'}
 */
export const MIN_LINES = 3;

const tileBodyFit = ({ scrollHeight, clientHeight, lineHeight }) => {
  if (!(scrollHeight > clientHeight + 1)) return 'fits';
  if (lineHeight > 0 && clientHeight < MIN_LINES * lineHeight) return 'hidden';
  return 'clipped';
};

export default tileBodyFit;
